import { useEffect, useRef } from 'react'
import { useCurrentUser } from '@wellesley/user'
import { usePushNotifications } from '../usePushNotifications'

export const usePushNotificationSetup = () => {
  const { user } = useCurrentUser()
  const {
    isSupported,
    permission,
    isRegistered,
    isLoading,
    error,
    register,
    unregister,
  } = usePushNotifications()

  const prevUserIdRef = useRef<string | undefined>(user?.id)

  useEffect(() => {
    if (
      !user?.id ||
      !isSupported ||
      isLoading ||
      isRegistered ||
      error ||
      permission === 'denied'
    ) {
      return
    }
    void register()
  }, [
    user?.id,
    isSupported,
    permission,
    isRegistered,
    isLoading,
    error,
    register,
  ])

  useEffect(() => {
    const wasLoggedIn = !!prevUserIdRef.current
    const isLoggedOut = !user?.id

    if (wasLoggedIn && isLoggedOut && isRegistered) {
      void unregister()
    }

    prevUserIdRef.current = user?.id
  }, [user?.id, isRegistered, unregister])

  return {
    isSupported,
    permission,
    isRegistered,
    isLoading,
    register,
    unregister,
  }
}
